import "./Admission.css";
import { useState, useEffect, useCallback } from "react";
import api from "../../utils/api";
import { useSearch } from "../../context/SearchContext";
import NewAdmission_Form from "../../Components/Forms/NewAdmission/NewAdmission_Form";

const Admission = () => {
  const { search } = useSearch();
  const [tempData, setTempData] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [display1, setDisplay1] = useState(0);

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  const fetchNewAdmission = useCallback(async () => {
    try {
      const res = await api.get(`/newadmission?page=${pagination.page}&limit=${pagination.limit}&search=${search}`);
      setTempData(res.data.data);
      setPagination((prev) => ({
        ...prev,
        total: res.data.pagination.total,
        totalPages: res.data.pagination.totalPages,
      }));
    } catch (err) {
      console.log(err);
    }
  }, [pagination.page, pagination.limit, search]);

  useEffect(() => {
    fetchNewAdmission();
  }, [fetchNewAdmission]);

  const handleStatusChange = async (id, status) => {
    try {
      await api.put(`/newadmission/status/${id}`, { status });
      setTempData((prev) => prev.map((item) => (item.id === id ? { ...item, status } : item)));
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  return (
    <div className="admission">
      {display1 ? <NewAdmission_Form setDisp={() => setDisplay1(0)} data={editData} isEdit={isEdit} setEdit={() => setIsEdit(false)} onSuccess={fetchNewAdmission} /> : null}

      <div className="admission__middle">
        <table>
          <tr className="admission__middle_tr">
            <th className="admission__middle_th">GR Number</th>
            <th className="admission__middle_th">Student Name</th>
            <th className="admission__middle_th">Parent Name</th>
            <th className="admission__middle_th">Parent Phone Number</th>
            <th className="admission__middle_th">Application</th>
            <th className="admission__middle_th">status</th>
            <th className="admission__middle_th"></th>
          </tr>
          {tempData &&
            tempData.map((data) => {
              return (
                <tr className="admission__middle_tr">
                  <td className="admission__middle_td">
                    <a href="#">{data.gr || "-"}</a>
                  </td>
                  <td className="admission__middle_td">{data.name || "-"}</td>
                  <td className="admission__middle_td banner">{data.father_name || "-"}</td>
                  <td className="admission__middle_td">{data.phone || "-"}</td>

                  <td className="admission__middle_td">
                    <a href="#">View Application</a>
                  </td>
                  <td className="admission__middle_td">
                    {data.status === "Pending" ? (
                      <div className="admission__middle_td_buttons">
                        <button type="button" className="admission__middle_td_button proceed" onClick={() => handleStatusChange(data.id, "Accepted")}>
                          Accept
                        </button>
                        <button type="button" className="admission__middle_td_button reject" onClick={() => handleStatusChange(data.id, "Rejected")}>
                          Reject
                        </button>
                      </div>
                    ) : (
                      <div className="admission__middle_td_buttons">
                        {data.status === "Accepted" ? (
                          <button type="button" className="admission__middle_td_button proceed">
                            Accepted
                          </button>
                        ) : (
                          <button type="button" className="admission__middle_td_button reject">
                            Rejected
                          </button>
                        )}
                      </div>
                    )}
                  </td>
                  <td>
                    <button
                      type="button"
                      className="circular__middle_td_edit"
                      onClick={() => {
                        setIsEdit(true);
                        setEditData(data);
                        setDisplay1(1);
                      }}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              );
            })}
        </table>
      </div>
      <div
        className="pagination-controls"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "20px",
          gap: "10px",
        }}
      >
        <button
          onClick={() => handlePageChange(pagination.page - 1)}
          disabled={pagination.page === 1}
          style={{
            padding: "5px 10px",
            cursor: pagination.page === 1 ? "not-allowed" : "pointer",
            opacity: pagination.page === 1 ? 0.5 : 1,
          }}
        >
          Previous
        </button>

        <span>
          Page {pagination.page} of {pagination.totalPages}
        </span>

        <button
          onClick={() => handlePageChange(pagination.page + 1)}
          disabled={pagination.page === pagination.totalPages}
          style={{
            padding: "5px 10px",
            cursor: pagination.page === pagination.totalPages ? "not-allowed" : "pointer",
            opacity: pagination.page === pagination.totalPages ? 0.5 : 1,
          }}
        >
          Next
        </button>

        <div style={{ marginLeft: "20px" }}>
          <label htmlFor="limit-select" style={{ marginRight: "10px" }}>
            Items per page:
          </label>
          <select
            id="limit-select"
            value={pagination.limit}
            onChange={(e) => {
              setPagination((prev) => ({
                ...prev,
                limit: Number(e.target.value),
                page: 1,
              }));
            }}
            style={{
              padding: "5px",
              marginLeft: "10px",
              backgroundColor: "rgb(239,239,239)",
            }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default Admission;
